import {
    GET_PROPERTY_MEMBERS,
    GET_PROPERTY_MEMBERS_SUCCESS,
    GET_PROPERTY_MEMBERS_FAILURE,
    GET_INVITED_PROPERTY_MEMBERS_SUCCESS,
    GET_INVITED_PROPERTY_MEMBERS_FAILURE,
    GET_MEMBER_KEYS,
    GET_MEMBER_KEYS_SUCCESS,
    GET_MEMBER_KEYS_FAILURE,
    RESET_PROPERTY_MEMBERS,
    RESET_MEMBER_KEYS,
    GET_PROPERTY_MEMBERS_CODES_SUCCESS,
    GET_PROPERTY_MEMBERS_CODES_FAILURE,
    GET_VG_PROPERTY_BY_ID_SUCCESS,
    GET_VG_PROPERTY_BY_ID_FAILURE
} from '../actions/types';

const INITIAL_STATE = {
    error: null,
    loading: null,
    members: null,
    invitedMembers: null,
    memberId: null,
    memberKeys: null,
    propertyId: null,
    membersCodes: null,
    property: null
};

const virtualGuardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_PROPERTY_MEMBERS:
            return {
                ...state,
                loading: true,
                propertyId: action.payload.propertyId
            };
        case GET_PROPERTY_MEMBERS_SUCCESS:
            return {
                ...state,
                loading: false,
                members: action.payload
            };
        case GET_INVITED_PROPERTY_MEMBERS_SUCCESS:
            return {
                ...state,
                loading: false,
                invitedMembers: action.payload
            };
        case GET_PROPERTY_MEMBERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_INVITED_PROPERTY_MEMBERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_MEMBER_KEYS:
            return {
                ...state,
                loading: true,
                memberId: action.payload.memberId
            };
        case GET_MEMBER_KEYS_SUCCESS:
            return {
                ...state,
                loading: false,
                memberKeys: action.payload
            };
        case GET_MEMBER_KEYS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case RESET_PROPERTY_MEMBERS:
            return {
                ...state,
                error: null,
                loading: null,
                members: null,
                invitedMembers: null,
                propertyId: null,
                membersCodes: null,
                property: null
            };
        case RESET_MEMBER_KEYS:
            return {
                ...state,
                error: null,
                loading: null,
                memberId: null,
                memberKeys: null
            };
        case GET_PROPERTY_MEMBERS_CODES_SUCCESS:
            return {
                ...state,
                loading: false,
                membersCodes: action.payload
            };
        case GET_PROPERTY_MEMBERS_CODES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case GET_VG_PROPERTY_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                property:
                    action.payload && action.payload.length ? action.payload[0] : null
            };
        case GET_VG_PROPERTY_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default virtualGuardReducer;
